import { Steps } from "antd";
import { useJobDetailFlow } from "hook/bailiff/job/flow/useJobDetail";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const JobStepper = () => {
  // -------------------------- VAR -----------------------------
  const { flow } = useJobDetailFlow();
  const items = [
    {
      title: "Đặt cọc",
    },
    {
      title: "AI dịch thuật",
    },
    {
      title: "AI sửa lỗi",
    },
    {
      title: "Hoàn tất",
    },
  ];
  // -------------------------- STATE ---------------------------
  const current = STEP_FLOW?.indexOf(flow) - 1;
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Steps
      className="job-stepper"
      labelPlacement="vertical"
      status="finish"
      items={items}
      current={current}
    />
  );
};
export default JobStepper;

const STEP_FLOW = ["waiting", "transcript", "support", "approval"];
